// extracted by mini-css-extract-plugin
export default {"zoomModal":"p2-z","image":"q2-z","button":"r2-z","isOverlayShown":"s2-z"};